import { render, staticRenderFns } from "./Ujian.vue?vue&type=template&id=c563bb24&scoped=true"
import script from "./Ujian.vue?vue&type=script&lang=js"
export * from "./Ujian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c563bb24",
  null
  
)

export default component.exports